export default "__VITE_ASSET__DfMyOa20__"